import { createSlice } from '@reduxjs/toolkit';
import { IServicePaymentsReducer } from 'types';
import { getServicePayments } from './actions';

const initialState: IServicePaymentsReducer = {
	isLoading: true,
	servicePayments: null,
};

const servicePaymentsSlice = createSlice({
	name: 'servicePaymentsSlice',
	initialState,
	reducers: {
		clearServicePaymentsData: (state) => {
			state.servicePayments = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getServicePayments.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(getServicePayments.fulfilled, (state, { payload }) => {
			state.servicePayments = payload;
			state.isLoading = false;
		});
		builder.addCase(getServicePayments.rejected, (state) => {
			state.isLoading = false;
		});
	},
});

export const { clearServicePaymentsData } = servicePaymentsSlice.actions;
export const servicePaymentsReducer = servicePaymentsSlice.reducer;
